import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const usePricing = () => useQuery({ queryKey: ["public-pricing"], queryFn: () => api.get("/public/pricing").then((r) => r.data), staleTime: 60000 });

export const usd = (c, dec = false) => `$${((c || 0) / 100).toLocaleString(undefined, { minimumFractionDigits: dec ? 2 : 0, maximumFractionDigits: dec ? 2 : 0 })}`;
export const usdSmart = (c) => usd(c, c % 100 !== 0);

export const PLAN_KEYS = ["essential", "ops_pro", "group"];

export const planBasis = (p, iv) => {
  if (p.pricing === "group") return `/${iv === "year" ? "yr" : "mo"} · includes ${p.included_locations} locations, then ${usd(p.extra_location_cents * (iv === "year" ? p.year_cents / p.month_cents : 1))}/${iv === "year" ? "yr" : "mo"} each`;
  return `/${iv === "year" ? "yr" : "mo"} per location`;
};

// answers: { locations, inventory, tips, costing, multi }
export function recommendPlan(a) {
  if (Number(a.locations) >= 3 || a.multi) return "group";
  if (a.inventory || a.tips || a.costing) return "ops_pro";
  return "essential";
}

const PRO_GOALS = ["Reduce food cost", "Reduce beverage cost", "Reduce waste", "Improve inventory accuracy", "Track comps/voids/discounts", "Reduce labor cost", "Increase sales"];
export const recommendFromGoals = (goals = [], concept = "", locations = 1) =>
  recommendPlan({ locations: concept.includes("Multi-Location") ? 3 : locations, inventory: goals.some((g) => PRO_GOALS.includes(g)) });

export const GATE_COPY = {
  inventory: { title: "Inventory & cost control", points: ["Barcode counts & par levels", "AI invoice capture you review line by line", "Recipe costing & beverage cost %", "Actual vs theoretical usage & variance"] },
  tips: { title: "Tip pools & tip-outs", points: ["Pool or individual tip-out rules", "Exact-to-the-cent reconciliation", "Employee tip statements", "Printable shift sheets & audit trail"] },
  csv_import: { title: "CSV sales imports", points: ["Import POS exports in seconds", "Saved column mappings", "Feeds your KPI dashboard & owner report"] },
  cost_controls: { title: "Cost-control analysis", points: ["Comp, void & discount analysis", "Waste & variance in dollars", "Clearly labeled estimates, never guarantees"] },
  owner_reporting: { title: "Weekly owner report", points: ["One-page weekly ownership view", "KPIs against your targets", "Printable & shareable"] },
  ai: { title: "AI summaries", points: ["Weekly narrative summaries", "Never invents numbers", "Traceable to your records"] },
  multi_location: { title: "Multi-location ownership dashboard", points: ["Every location on one screen", "Cross-location comparison", "Group-level KPIs"] },
};

export const STATUS_TONE = { Live: "bg-emerald-50 text-emerald-800", Beta: "bg-sky-50 text-sky-800", "Limited Pilot": "bg-violet-50 text-violet-800", Planned: "bg-stone-100 text-stone-600", "Integration Setup Required": "bg-amber-50 text-amber-800" };
